import { commonActions } from '../actions/constant';

const { STORE_SUBDOMAIN_REDUX, RESET_SUBDOMAIN_REDUX } = commonActions;

const intitialstate: string = '';

export const storeSubdomainReduxReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case STORE_SUBDOMAIN_REDUX:
      return action.subdomain;

    case RESET_SUBDOMAIN_REDUX:
      return intitialstate;

    default:
      return state;
  }
};
